<template>
  <div class="wrap">
    <div class="boxCard">
      <el-card class="box-card" :body-style="{padding: '0'}">
        <div slot="header" class="clearfix">
          <span>会员中心</span>
        </div>
        <el-form :inline="true" :model="queryParams" ref="queryParams" class="demo-form-inline">
          <el-form-item label="会员姓名" prop="memberName">
            <el-input v-model="queryParams.memberName" placeholder="请输入会员姓名"></el-input>
          </el-form-item>
          <el-form-item label="手机号码" prop="photoNumber">
            <el-input v-model="queryParams.photoNumber" placeholder="请输入手机号码"></el-input>
          </el-form-item>
          <el-form-item label="所属门店" prop="storeId">
            <el-select v-model="queryParams.storeId" placeholder="请选择所属门店">
              <el-option label="全部" value="" />
              <el-option v-for="(item,index) in storeList" :key="index" :label="item.storeName" :value="item.id" />
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="resetQuery">查询</el-button>
            <el-button @click="resetForm('queryParams')">重置</el-button>
          </el-form-item>
        </el-form>
      </el-card>
    </div>
    <div class="boxCard">
      <el-card class="box-card" :body-style="{padding: '0'}">
        <div slot="header">
          <span class="tabTitle">会员列表</span>
          <el-button type="primary" @click="addMember">新增会员</el-button>
        </div>
        <el-table :data="tableData" show-header border style="width: 100%">
          <el-table-column type="index" align="center" label="序号" />
          <el-table-column prop="memberName" align="center" label="姓名" />
          <el-table-column prop="photoNumber" align="center" label="手机号码" />
          <el-table-column align="center" label="性别">
            <template slot-scope="scope">{{scope.row.memberSex == 1 ? '男' : '女'}}</template>
          </el-table-column>
          <el-table-column prop="memberAge" align="center" label="年龄" />
          <el-table-column prop="memberAddress" align="center" label="所在地区">
            <template slot-scope="scope">
              {{(scope.row.memberAddress||'').replace(/,/g,'')}}
            </template>
          </el-table-column>
          <el-table-column prop="storeName" align="center" label="所属门店" />
          <el-table-column prop="memberType" align="center" label="会员类型">
            <template slot-scope="scope">
              {{scope.row.memberType == '2' ? '慢病会员':'普通会员'}}
            </template>
          </el-table-column>
          <el-table-column prop="memberLevel" align="center" label="会员等级">
            <template slot-scope="scope">
              {{scope.row.memberLevel == '2' ? '付费会员':'普通会员'}}
            </template>
          </el-table-column>
          <el-table-column prop="memberLabelNames" align="center" label="会员标签" />
          <el-table-column label="操作" align="center" fixed="right" width="150">
            <template slot-scope="scope">
              <el-button size="mini" @click="toDetail(scope.row)">详情</el-button>
              <!-- <el-button size="mini" type="success" @click="editMember(scope.row)">编辑</el-button> -->
            </template>
          </el-table-column>
        </el-table>
        <el-pagination :current-page.sync="pageNum" :page-size="pageSize" @size-change="barSizeChange" @current-change="barCurrentChange" :page-sizes="[10, 20, 30, 40, 50]" background="" layout="sizes, prev, pager, next" :total="totalCount"></el-pagination>
      </el-card>
    </div>
    <!-- 会员 -->
    <my-from-dialog :isShow="isShowDiaFlag" :title="diaTitle" @cancel="closePup" @ok="closePup('ok')" @closeCallBack="closePup" :isFullscreen="true" :scrollHeight="''" :dialogWidth="'500px'" :okBtnText="'保 存'" :cancelBtn="false" :okBtn="false">
      <template slot="froms">
        <!-- <member-info :isShow="isShowDiaFlag" :pageType="'1'" :memberId="memberId" ref="memberDom" @isEdit="closeMemberPup" /> -->
        <information-add :isShow="isShowDiaFlag" @success="closeMemberPup" v-if="editType" path="informationAdd" :type="parseInt(3)" @handleEdit="handleEdit" :memberId="memberId" />
      </template>
    </my-from-dialog>
  </div>
</template>

<script>
import informationAdd from './information_add.vue'
import myFromDialog from '@/components/common/from_dialog'; // 弹窗
import memberInfo from '@/components/common/user/member_info'; // 可编辑会员表单组件
// import { getDate, getHms, objDeepCopy } from '@/utils/index';
export default {
  components: { myFromDialog, memberInfo, informationAdd },
  watch: {},
  data() {
    return {
      squareUrl: "https://cube.elemecdn.com/9/c2/f0ee8a3c7c9638a54940382568c9dpng.png",
      // ================================= 弹窗-s
      diaTitle: '新增会员', // 弹窗标题
      isShowDiaFlag: false, // 是否显示新增or编辑表单
      // ================================= 弹窗 -e
      // ================================= 分页 -s
      pageNum: 1,
      pageSize: 10,
      totalCount: 0,
      // ================================= 分页 -e
      queryParams: { // 查询条件表单
        memberName: '', // 会员名称
        photoNumber: '', // 手机号码
        storeName: '', // 所属门店
      },
      loginData: JSON.parse(localStorage.getItem('loginData')) || {}, // 登录药企基本信息
      storeList: [], // 门店列表
      tableData: [], // 会员列表数据
      memberId: '', // 当前会员ID
      editType: 1
    }
  },
  created() {
    this.getStoreList();
    this.getMemberList();
  },
  methods: {
    // 点击编辑
    handleEdit(val) {
      this.editType = 0
      this.$nextTick(_ => {
        this.editType = val;
      })
    },
    resetQuery() { // 查询
      this.pageNum = 1;
      this.pageSize = 10;
      this.getMemberList();
    },
    resetForm(formName) { // 表单重置
      this.$refs[formName].resetFields();
      this.getMemberList();
    },
    // =================================================================================== 分页 -s
    barSizeChange(val) { // 当前显示条数
      this.pageSize = val;
      this.getMemberList();
    },
    barCurrentChange(val) { // 当前页
      this.pageNum = val;
      this.getMemberList();
    },
    // =================================================================================== 分页 -e
    // =================================================================================== 弹窗 -s
    closePup(state) { // 关闭弹窗
      if (state == 'ok') {
        this.getMemberList();
      }
      this.isShowDiaFlag = false;
    },
    closeMemberPup(state) { // 关闭弹窗
      this.isShowDiaFlag = state;
      this.getMemberList();
    },
    // =================================================================================== 弹窗 -e
    getStoreList() {  // 获取门店列表
      let _this = this;
      this.$https.get('system/store/findAll', { enterpriseId: this.loginData.enterpriseId }).then(res => {
        _this.storeList = res.data || [];
        console.log('获取门店列表========>', res);
      }).catch(res => {

      })
    },
    getMemberListParams() {  // 获取会员列表请求参数
      return {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        memberName: this.queryParams.memberName,
        photoNumber: this.queryParams.photoNumber,
        storeId: this.queryParams.storeId,
        enterpriseId: this.loginData.enterpriseId,
        needComPms: true
      }
    },
    getMemberList() { // 获取会员列表
      this.$https.post('system/member/list', this.getMemberListParams()).then(res => {
        if (res.code === 200) {
          this.tableData = res.data.records || [];
          this.totalCount = res.data.total || 0;
        } else {
          this.$message.error('会员列表接口请求异常');
        }
        // _this.getOrderList();
        console.log('获取会员列表=>>>>>>>>', res);
        // _this.$message.success('取消订单成功');
      }).catch(res => {

      })
    },
    addMember() { // 新增会员
      this.memberId = null;
      this.diaTitle = '新增会员';
      this.isShowDiaFlag = true;
    },
    editMember(rows) { // 编辑会员
      this.memberId = rows.id;
      this.diaTitle = '编辑会员';
      this.isShowDiaFlag = true;
    },
    toDetail(row) { // 会员详情
      //跳转时页面
      this.$router.push({ path: '/user_info_manage', query: { memberId: row.id } });
      // this.$router.push({
      //   path: "/user_info_manage",
      //   query: { id: row.id, editType: 1, enterpriseId: row.enterpriseId }
      // });
    },
  }
}
</script>

<style lang="less" scoped>
.boxCard {
    margin-bottom: 20px;
}
.tabTitle {
    color: #333;
    font-size: 15px;
    font-weight: bold;
    margin-right: 30px;
}

.memberInfo {
    padding: 20px;
    .left {
        display: flex;
        display: -webkit-flex;
        border-right: 1px solid #e4e4e4;
        .avatarWrap {
            margin-right: 20px;
        }
        .info {
            color: #333;
            font-size: 15px;
            .first_p {
                margin-bottom: 15px;
                .two {
                    margin: 0 35px;
                }
            }
        }
    }
    .right {
        padding: 0 20px;
        .label {
            margin-bottom: 10px;
        }
        .labels /deep/ .el-tag:first-child {
            margin-left: 0;
        }
        .labels /deep/ .el-tag {
            margin-left: 15px;
        }
    }
}
.baseInfoBtnBox {
    padding: 10px;
}
</style>
